import { FieldValues, useFormContext } from 'react-hook-form';
import { Stack } from '@optimus-web/core';
import { CurrencyInputField } from '@mews-commander/form';
import { useLocalizeCurrency } from '@mews/framework';
import { FormFieldHintIcon } from '../steps/taxation/FormFieldHintIcon';
import { useCurrencyFormat } from '../../../../../core/globalization/hooks/useCurrencyFormat';

interface Props {
    defaultCurrencyCode: string;
    fieldName: string;
}

export const BasePriceCell = ({ defaultCurrencyCode, fieldName }: Props) => {
    const { getFieldState } = useFormContext<FieldValues>();

    const { isDirty } = getFieldState(fieldName) || {};
    const currencyFormat = useCurrencyFormat(defaultCurrencyCode);
    const localizeCurrency = useLocalizeCurrency();

    return (
        <Stack spacing="200" itemAlignment="center" distribution="stretch" fill>
            <CurrencyInputField
                {...currencyFormat}
                inline
                name={fieldName}
                placeholder={isDirty ? '' : localizeCurrency(0, defaultCurrencyCode)}
            />
            <FormFieldHintIcon fieldName={fieldName} />
        </Stack>
    );
};
